import { useQuery } from '@tanstack/react-query';
import type AgentApiAllianceApplicationsShow from '@/types/serializers/AgentApiAllianceApplicationsShow';

export const AGENT_ALLIANCE_APPLICATION_DETAIL_QUERY_KEY = [
  'agent_alliance_application_detail',
] as const;

export default function useFetchAgentAllianceApplicationDetail(id: string | null) {
  return useQuery({
    queryKey: [...AGENT_ALLIANCE_APPLICATION_DETAIL_QUERY_KEY, id],
    enabled: id !== null,
    queryFn: async () => {
      const response = await fetch(`/agent/api/alliance_applications/${id}`);
      if (!response.ok) {
        throw new Error('応募詳細の取得に失敗しました');
      }
      const data: AgentApiAllianceApplicationsShow = await response.json();
      return data;
    },
  });
}
